document.addEventListener('DOMContentLoaded', function () {
  var images = document.querySelectorAll('.multicolumn-card__image');
  if (!images.length) return;

  // Build the lightbox once and append to the page
  var lightbox = document.createElement('div');
  lightbox.className = 'mc-lightbox';
  lightbox.innerHTML =
    '<button class="mc-lightbox__close" aria-label="Close">&times;</button>' +
    '<img class="mc-lightbox__img" src="" alt="">';
  document.body.appendChild(lightbox);

  var lightboxImg = lightbox.querySelector('.mc-lightbox__img');
  var closeBtn = lightbox.querySelector('.mc-lightbox__close');

  function openLightbox(src, alt) {
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.classList.add('is-open');
    document.body.classList.add('mc-lightbox-open');
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.classList.remove('mc-lightbox-open');
    lightboxImg.src = '';
  }

  images.forEach(function (img) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function () {
      var fullSrc = img.currentSrc || img.src;
      openLightbox(fullSrc, img.alt);
    });
  });

  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
});